<template>
    <div class="search-result-wrapper card" @click="onClickItem(item)">
        <strong>{{ item.formatted_address }}</strong>
    </div>
</template>

<script>
    export default {
        name: 'place-results-template',
      props: {
        item: { required: true }
      },
        methods: {
            onClickItem(item) {
                this.$emit('place-clicked', item)
            }
        }
    }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// placeResultsTemplate.vue?846630d0